/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useContext, useEffect } from 'react';
import Input from './common/Input';
import { Pencil, XSquare } from 'react-bootstrap-icons';
import { Link } from "react-router-dom";
import { Badge, Form } from 'react-bootstrap';
import { CoreContext } from '../context/core-context';
import { AuthContext } from '../context/auth-context';
import { useForm } from "react-hook-form";


const Generals = () => {

    const coreContext = useContext(CoreContext);
    const authContext = useContext(AuthContext);
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');


    const fetchClient = () => {
        coreContext.fetchSelfGenerals(authContext.itemId);
    }

    const { register, handleSubmit, errors } = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onBlur',
    });

    useEffect(fetchClient, []);

    const populateClient = () => {
        setTitle(coreContext.client.general_title);
        setMessage(coreContext.client.general_message);
    }

    useEffect(populateClient, [coreContext.client]);

    const deleteGeneral = (id) => {
        const r = confirm("Delete Item ?");
        if (r === true) {
            coreContext.deleteGeneral(id, coreContext.client.id);
        } else {

        }


    }

    const renderGenerals = () => {
        const generals = coreContext.generals;
        if (generals)
            return generals.map(general => <tr key={general.id}><td>{general.title}</td><td>{general.edate}</td><td>{general.displayOrder}</td><td><Link className="btn btn-primary btn-sm" title='Edit general' to={`/general/${general.id}`}><Pencil size="12" /></Link></td><td><button onClick={() => deleteGeneral(general.id)} type="button" className="btn btn-danger btn-sm" title="Delete Item"> <XSquare size="12" /> </button></td></tr>)
    }

    const onTitleChangedHandler = (e) => {
        setTitle(e.target.value);
    }
    const onMessageChangedHandler = (e) => {
        setMessage(e.target.value);
    }

    const onGeneralSectionHandler = (data) => {
        coreContext.updateGeneralSection(title, message, authContext.itemId);

    }


    return (<div className='container-fluid'>
        <div className="card">
            <div className="card-title mx-auto"><h3><Badge variant="success">General Section</Badge></h3></div>
            <div className="card-body">
                <Form autoComplete='off' onSubmit={handleSubmit(onGeneralSectionHandler)} noValidate>
                    <Input label='Title' value={title} name='title' minLength={2} maxLength={155} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Title' onChange={onTitleChangedHandler} />

                    <Input label='Image Message' value={message} name='message' minLength={2} maxLength={2000} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Message' onChange={onMessageChangedHandler} />

                    <Input elementType='button' variant='primary' value="Update" /> &nbsp;&nbsp; {coreContext.renderLoader()} &nbsp;&nbsp;
                    <Input variant='danger' label={coreContext.message} elementType='label' />
                    &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; <Link to="/add-general">Add General Item</Link>
                </Form>
            </div>
        </div>
        <div className="card">
            <div className="card-title mx-auto"><h3><Badge variant="success">General Section</Badge></h3></div>
            <div className="card-body">
                <table className="table table-bordered table-sm">
                    <thead>
                        <tr><th>Title</th><th>Date</th><th>Inverse Display Order</th><th></th><th></th></tr>
                    </thead>
                    <tbody>
                        {renderGenerals()}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    )
}

export { Generals }